export default "__VITE_ASSET__DSrP1v5J__"